export default {
  API_ENDPOINT: 'https://infinite-beyond-21412.herokuapp.com/api',
  TOKEN_KEY: '242ed342-0935-4e6e-92cb-9f142b22e0e2',
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL ||
    "http://localhost:3002/api"
}
